/* @flow */
import { useTouchScreenUI } from "../searchdiscover/toggles";

/**
 * This function tries to detect whether the user is using a touch screen. This is only for cases where we want to show
 * a touch-optimized UI (e.g. adding +/- buttons on a number input). Before using this, consider whether that is really
 * what you want, or whether you'd rather make the layout depend on screen size or the hover media query.
 */
export function isTouchScreen(): boolean {
    if (useTouchScreenUI()) {
        return true;
    }
    if (window.PointerEvent && "maxTouchPoints" in navigator) {
        // if Pointer Events are supported, just check maxTouchPoints
        return navigator.maxTouchPoints > 0;
    } else {
        // no Pointer Events or no maxTouchPoints (e.g. Safari)
        return !!(
            // any-pointer:coarse mostly means touchscreen
            (
                (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches) ||
                // last resort - check for exposed touch events API / event handler
                window.TouchEvent ||
                "ontouchstart" in window
            )
        );
    }
}
